import httpManager from "@/app/shared/utils/httpManager";

/**
 * Agregar nueva direccion.
 * @param {number} ticketId Identificador del ticket.
 * @param {Object} addresse Datos de direccion.
 *
 * @return {Promise<Object>} Datos de la direccion creada
 */
export async function addAddressesClient(ticketId, addresse) {
  const url = `/workspace/tickets/${ticketId}/addresses/`;
  const response = await httpManager.post(url, addresse);
  return response.data;
}
